import React, { useState, useEffect, useMemo } from 'react';
import { TableBasicClick } from 'components';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid'
import { useLocations, useEditLocation } from 'hooks/locations.hook';
import * as Icon from 'react-bootstrap-icons';
import { dateTime, date, time24to12_2d } from 'helpers/formatter';

export { ManageProfileLocationHistoryCalendar };

function ManageProfileLocationHistoryCalendar() {
  const [validated, setValidated] = useState(false);
  const [locations, setlocations] = useState([]);
  const [showLocationDialog, setShowLocationDialog] = useState(false);
  const [showLocationsDialog, setShowLocationsDialog] = useState(false);
  const [showEditLocationName, setShowLocationName] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [events, setEvents] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([])
  const [yearRange, setYearRange] = useState([]);
  const [isSaved, setIsSaved] = useState(false);

  const editLocationMutation = useEditLocation();

  const handleEditLocationClose = () => { setShowLocationDialog(false); }
  const handleEditLocationNameClose = () => { 
    setShowLocationName(false);
  }

  const { data: locationsData, isError: locationsIsError, error: locationsError, isLoading: locationsIsLoading } = useLocations();
  useEffect(() => {
    if (locationsData !== undefined) {
      setTimeout(function () {
        setlocations(locationsData);
        if (events.length === 0) {
          for (var i in locationsData) {
            let title = locationsData[i].address;
            if (locationsData[i].name != null) {
              if (locationsData[i].name.length > 0) {
                title = locationsData[i].name + " - " + title;
              }
            }
            let start = new Date(locationsData[i].durationStart);
            start = start.setHours(start.getHours() - 5);
            let end = new Date(locationsData[i].durationEnd);
            end = end.setHours(end.getHours() - 5);
            events.push({ 'id': locationsData[i].id, 'start': start, 'end': end, 'title': title, 'description': locationsData[i].address });
          }
        }
      }, 500);

      var currentYear = new Date().getFullYear(), years = [];
      var startYear = 2010;  
      while (startYear <= currentYear) {
          years.push(currentYear--);
      }   
      setYearRange(years);
    }
  }, [locationsData, events]);

  const viewLocationOnClick = (e) => {
    if (e.event !== undefined) {
      setShowLocationName(false);
      let l = locations.filter((item) => item.id === e.event.id);
      if (l && l.length > 0) {
        setSelectedLocation(l[0]);
      }
      setShowLocationDialog(true);
      //window.open("https://www.google.com/maps/place/" + e.event._def.extendedProps.description);
    }
  }

  const handleEditLocation = (e) => {
    setShowLocationName(true);
    setIsSaved(e.isSaved);
  };

  const handleEditLocationSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      let l = selectedLocation;
      l.name = form.formLocationName.value;
      setSelectedLocation(l);
      editLocationMutation.mutate({
        id: selectedLocation.id,
        name: form.formLocationName.value,
        isSaved: isSaved
      });

      const newEvents = events.map((e) => {
        if (e.id === selectedLocation.id) {
            let title = l.address;
            if (l.name != null) {
              if (l.name.length > 0) {
                title = l.name + " - " + title;
              }
            }
            let start = new Date(selectedLocation.durationStart);
            start = start.setHours(start.getHours() - 5);
            let end = new Date(selectedLocation.durationEnd);
            end = end.setHours(end.getHours() - 5);
            return { ...e, id: selectedLocation.id, start: start, end: end, title: title, description: selectedLocation.address };
        }
        else {
            return e;
        }
      });

      setEvents([]);
      setTimeout(function () {
          setEvents(newEvents);
      }, 500);

      setShowLocationName(false);
      setValidated(false);
    }
    else {
      setValidated(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };
  const calendarChangeOnClick = (e) => {
    let start = new Date(e.start);
    start = start.setHours(start.getHours() + 12);
    let end = new Date(e.end);
    end = end.setHours(end.getHours() + 12);
    setFilteredLocations(locations.filter(item => new Date(item.durationStart) >= start && new Date(item.durationStart) <= end).sort((a, b) => a.durationStart > b.durationStart ? 1 : -1)
    .map(item => { 
      let i = item;
      if (i.name === null) {
        i.name = i.address;
      }
      return i; 
    }));   
  }

  const formatTrProps = (state = {}) => {
    return { onClick: () => viewLocationOnClick({'event':{ 'id': state.original.id, 'start': state.original.start, 'end': state.original.end, 'title': state.original.title, 'description': state.original.address }}) };
  };
  const columns = useMemo(() => [
    {
        Header: "Location",
        accessor: "name",
    },
    {
        Header: "Date",
        accessor: "durationStart",
        Cell: ({ row }) => (
            date(new Date(row.original.durationStart).setHours(new Date(row.original.durationStart).getHours() - 5))
        )
    },
    {
        Header: "Time",
        accessor: "timeStart",
        Cell: ({ row }) => (
            <div>
                {!row.original.durationStart.includes("00:00:00") && (time24to12_2d(new Date(row.original.durationStart).setHours(new Date(row.original.durationStart).getHours() - 5)))}
            </div>
        )
    }
], []);

  return (
    <div>
      {locationsIsLoading && <div className='text-center'><div className="spinner-border spinner-border-lg"></div></div>}
      {events && events.length > 0 &&
        <div className='calendar-container'>
          <p>&nbsp;</p>
          <div className='row'>
            <div className='col-lg-8 no-padding-lg text-left'>
              <FullCalendar
                headerToolbar={{
                  start: "today prev next",
                  end: "dayGridMonth timeGridWeek timeGridDay",
                  center: "title"
                }}
                events={events}
                plugins={[daygridPlugin, timeGridPlugin]}
                views={["dayGridMonth", "timeGridWeek", "timeGridDay"]}
                eventClick={(e) => viewLocationOnClick(e)}
                datesSet={(e) => calendarChangeOnClick(e)}
              />
              <p>&nbsp;</p>
            </div>
            <div className='no-padding-lg col-lg-4'>
            {filteredLocations && <TableBasicClick responsive columns={columns} data={filteredLocations} formatRowProps={(state) => formatTrProps(state)} />}
            {locationsIsError && <div className="text-danger">Error loading cards: {locationsError.message}</div>}
            </div>
          </div>
        </div>
      }

      <Modal
          size="xl"
          show={showLocationDialog}
          onHide={handleEditLocationClose}
          aria-labelledby="modal-view-location"
          dialogClassName='modal-full-height'
      >
          <Modal.Header closeButton closeVariant='white'>
              <Modal.Title id="modal-view-location">
                  Map
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <a className="btn-card-viewer" href={`https://www.google.com/maps/place/"${selectedLocation.address}'`} target='_blank' rel="noreferrer"><Icon.WindowFullscreen size={20} /></a>
            <h2>{selectedLocation.name} <button className="button-text" onClick={(e) => handleEditLocation(selectedLocation)}><Icon.ThreeDots size={40} /></button></h2>
            {showEditLocationName &&
              <div>
                <Form noValidate validated={validated} onSubmit={handleEditLocationSubmit}>
                  <Form.Group className="mb-3" controlId="formLocationName">
                    <Form.Label>Location Name</Form.Label>
                    <Form.Control required type="text" maxLength="50" placeholder="Enter a location name" autoComplete="off" defaultValue={selectedLocation.name} />
                    <Form.Control.Feedback type="invalid">Please enter a location name.</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formIsSaved">
                    <Form.Label>Saved</Form.Label>
                    <Form.Check type="switch" defaultChecked={selectedLocation.isSaved} onChange={(e) => { setIsSaved(!isSaved); }} />
                    <br /><br />
                  </Form.Group>
                  <Button variant="primary" type="submit">Save</Button>&nbsp;
                  <Button variant="secondary" type="button" onClick={handleEditLocationNameClose}>Cancel</Button>
                </Form>
                <p></p>
              </div>
            }
            <hr/>
            {selectedLocation.address !== selectedLocation.name && <h4>{selectedLocation.address}</h4>}
            <p></p>
            <p><strong>{dateTime(new Date(selectedLocation.durationStart).setHours(new Date(selectedLocation.durationStart).getHours() - 5))}</strong> to <strong>{dateTime(new Date(selectedLocation.durationEnd).setHours(new Date(selectedLocation.durationEnd).getHours() - 5))}</strong> 
            {locations && locations.filter(item => item.address === selectedLocation.address).length > 1 ? <button className='map-history-btn' onClick={() => setShowLocationsDialog(!showLocationsDialog)}><Icon.ClockFill size={18}/></button> : <></> }</p>
            <p></p>
            {selectedLocation.address && selectedLocation.address.length > 0 && <iframe style={{width:"100%",height:"100%"}} src={'https://maps.google.com/maps?q=' + selectedLocation.address.replace("#", "") + '&t=&z=16&ie=UTF8&iwloc=&output=embed'}></iframe> }
            <div className='bottom-border'></div>
          </Modal.Body>
      </Modal>

      <Modal
          size="lg"
          show={showLocationsDialog}
          onHide={() => setShowLocationsDialog(false)}
          aria-labelledby="modal-view-locations"
      >
          <Modal.Header closeButton closeVariant='white'>
              <Modal.Title id="modal-view-locations">
                  {selectedLocation.name && selectedLocation.name.length > 0 ? <>{selectedLocation.name}</> : <>{selectedLocation.address}</>}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5 className='text-center'>{selectedLocation.name && selectedLocation.name.length > 0 ? <>{selectedLocation.address}</> : <></> }</h5>
            <hr/>
            {locations && locations.filter(item => item.address === selectedLocation.address).sort((a, b) => a.durationStart < b.durationStart ? 1 : -1).map(loc => {
              let start = new Date(loc.durationStart);
              start = start.setHours(start.getHours() - 5);
              let end = new Date(loc.durationEnd);
              end = end.setHours(end.getHours() - 5);
              return <div key={loc.id}><div className='map-date-light text-center'>{dateTime(start)} to {dateTime(end)}</div><hr/></div>
            })}

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" type="button" onClick={() => setShowLocationsDialog(false)}>Close</Button>
          </Modal.Footer>
      </Modal>
    </div>
  );
}